import { ContentLoader, Select as SelectUiKit, SelectOption } from "@rio-cloud/rio-uikit"
import { useIntl } from "react-intl"

const Input = ({ label, value, disabled, isLoading, onChange, error, placeholder }: { label: string, value?: string | number, disabled?: boolean, isLoading: boolean, error?: boolean, onChange?: (value: string) => void, placeholder?: string}) => {
    const intl = useIntl();

    return (
        <div className="form-group form-group-lg width-100pct">
            <label htmlFor={label}>{label}</label>

            {isLoading ? (
                <div style={{ height: 45, overflow: 'hidden', borderRadius: 8 }}>
                    <ContentLoader className="width-100pct height-100pct" />
                </div>
            ) : (
                <input id={label} className="form-control" type="text" value={value} disabled={disabled} onChange={(ev) => onChange?.(ev.target.value)} placeholder={placeholder} />
            )}
            <div className="height-15">
                {error ? <span className="text-size-12 text-color-danger">{intl.formatMessage({ id: "intl-msg:support.custom.fieldRequired" })}</span> : null}
            </div>
        </div>
    )
}

const TextArea = ({ label, value, disabled, isLoading, onChange, error, placeholder }: { label: string, value?: string | number, disabled?: boolean, isLoading: boolean, onChange: (value: string) => void, error?: boolean, placeholder?: string }) => {
    const intl = useIntl();

    return (
        <div className="form-group form-group-lg width-100pct">
            <label htmlFor={label}>{label}</label>

            {isLoading ? (
                <div style={{ height: 100, overflow: 'hidden', borderRadius: 8 }}>
                    <ContentLoader className="width-100pct height-100pct" />
                </div>
            ) : (
                <textarea value={value} disabled={disabled} placeholder={placeholder} className="form-control min-height-150" rows={10} id="textArea" onChange={(e) => onChange(e.target.value)}></textarea>
            )}
            <div className="height-15">
                {error ? <span className="text-size-12 text-color-danger">{intl.formatMessage({ id: "intl-msg:support.custom.fieldRequired" })}</span> : null}
            </div>
        </div>
    )
}

const Select = ({ label, options, value, onChange, isLoading, placeholder, error, disabled }: { label: string, options: SelectOption[], value?: string[], onChange: (id?: string) => void; isLoading?: boolean, placeholder?: string, error?: boolean, disabled?: boolean }) => {
    const intl = useIntl();

    return (
        <div className="form-group form-group-lg width-100pct">
            <label htmlFor="type">{label}</label>
            {isLoading ? (
                <div style={{ height: 45, borderRadius: 8, overflow: 'hidden' }}>
                    <ContentLoader className="width-100pct height-100pct" />
                </div>
            ) : (
                <SelectUiKit
                    id={label}
                    bsSize='lg'
                    value={value}
                    onChange={(item) => onChange(item?.id)}
                    options={options}
                    placeholder={placeholder || intl.formatMessage({ id: "intl-msg:support.custom.selectPlaceholder" })}
                    useClear
                    disabled={disabled}
                />
            )}
            <div className="height-15">
                {error ? <span className="text-size-12 text-color-danger">{intl.formatMessage({ id: "intl-msg:support.custom.fieldRequired" })}</span> : null}
            </div>
        </div>
    )
}

export const Custom = {
    Select,
    TextArea,
    Input
}